// extracted by mini-css-extract-plugin
export var products_video_height = "styles-module--products_video_height--ff08f";